import { render } from "./CompleteProfile.vue?vue&type=template&id=79c5eec0"
import script from "./CompleteProfile.vue?vue&type=script&lang=js"
export * from "./CompleteProfile.vue?vue&type=script&lang=js"

import "./CompleteProfile.vue?vue&type=style&index=0&id=79c5eec0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__